import React, { Component } from "react";
import { connect } from "react-redux";
import Content from "../../content/Content";
import Store from "../../content/Store";
import { shouldShowIfAllSMEModulesDontMatch } from "../../helpers/SMEModules/smeModuleHelper";
import HomeCard from "./HomeCard";
import {
    nonClaimsModules,
} from "../../constants/SMEModulesToMatchOn";
import {
    ButtonConfig
  } from "../../constants/Constants";

export class EapCard extends Component {
    static content = Store.Home;

    GetMatchedImage(matches, imgSrcMobile, imgSrc) {
        return matches ? (
            <img src={imgSrcMobile} alt="" aria-hidden />
        ) : (
            <img src={imgSrc} alt="" aria-hidden />
        );
    }

    render() {
        return (
            <div className="row row-color">
                <div className={
                        "col-sm-12 col-lg-6"
                    }
                    data-access-health-support-home-card>
                    <Content
                        names={[
                            Store.Home.Cards.HomeEAPpolicySrc.IconSrc,
                            Store.Home.Cards.HomeEAPpolicySrc.Heading,
                            Store.Home.Cards.HomeEAPpolicySrc.Description,
                            Store.Home.Cards.HomeEAPpolicySrc.LinkText,
                            Store.Home.Cards.HomeEAPpolicySrc.LinkTo,
                            Store.Home.Cards.HomeEAPpolicySrc.ExternalLinkTo
                        ]}
                    >
                        {(
                            iconSrc,
                            heading,
                            description,
                            linkText,
                            linkTo,
                            externalLinkTo
                        ) => (
                            <HomeCard
                                IconSrc={iconSrc}
                                Heading={heading}
                                Description={description}
                                LinkText={linkText}
                                LinkTo={linkTo}
                                ExternalLinkTo={externalLinkTo}
                                id={ButtonConfig.HomeIndcta_mol_hp_docs}
                            />
                        )}
                    </Content>
                </div>

                <div
                    className={
                        "col-sm-12 col-lg-6"
                    }
                    data-access-health-support-home-card
                >
                    <Content
                        names={[
                            Store.Home.Cards.HomeTouchSrc.IconSrc,
                            Store.Home.Cards.HomeTouchSrc.Heading,
                            Store.Home.Cards.HomeTouchSrc.Description,
                            Store.Home.Cards.HomeTouchSrc.LinkText,
                            Store.Home.Cards.HomeTouchSrc.LinkTo,
                            Store.Home.Cards.HomeTouchSrc.ExternalLinkTo
                        ]}
                    >
                        {(
                            iconSrc,
                            heading,
                            description,
                            linkText,
                            linkTo,
                            externalLinkTo
                        ) => (
                            <HomeCard
                                IconSrc={iconSrc}
                                Heading={heading}
                                Description={description}
                                LinkText={linkText}
                                LinkTo={  linkTo }
                                ExternalLinkTo={externalLinkTo}
                                id={ButtonConfig.HomeIndcta_mol_hp_mess}
                            />
                        )}

                    </Content>
                </div>
            </div>
        );
    }
}

export const mapStateToEapCard = (state) => {
    const { IsLapsed: isLapsed, IsFormat2: isFormat2, IsSME: isSME } =
        state.policyReducer.selectedPolicy || {};
    return {
        shouldShowClaims: shouldShowIfAllSMEModulesDontMatch(
            state.policyReducer && state.policyReducer.selectedPolicy,
            nonClaimsModules
        ),
        isLapsed,
        isFormat2,
        isSME
    };
};

export default connect(
    mapStateToEapCard
)(EapCard);
